import { array } from '@ember/helper';
import link from 'ember-link/helpers/link';
import RouteTemplate from 'ember-route-template';
import QuestionnaireForm from 'garaje/components/visitors/questionnaires/form';

import type { VisitorsQuestionnairesCreateRouteModel } from './route';

interface Signature {
  Args: {
    model: VisitorsQuestionnairesCreateRouteModel;
  };
}

export default RouteTemplate<Signature>(
  <template>
    {{#let (link route="visitors.questionnaires") as |indexRouteLink|}}
      <QuestionnaireForm
        @availableLocales={{(array)}}
        @backLink={{indexRouteLink}}
        @canDeleteQuestionnaires={{false}}
        @changedModels={{@model.changes}}
        @defaultLocale={{@model.location.locale}}
        @fetchFlowsPage={{@model.fetchFlowsPage}}
        @flows={{@model.flows}}
        @questionnaire={{@model.questionnaire}}
        @onSave={{indexRouteLink.transitionTo}}
      />
    {{/let}}
  </template>,
);
